import { render, staticRenderFns } from "./BankExpert.vue?vue&type=template&id=ff92bfda&scoped=true&"
import script from "./BankExpert.vue?vue&type=script&lang=js&"
export * from "./BankExpert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff92bfda",
  null
  
)

export default component.exports